import { Component, forwardRef, ViewChild, Input, HostBinding, Output, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
const INLINE_EDIT_CONTROL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ToggleSlideComponent),
  multi: true
};
@Component({
  selector: 'scaffold-toggle-slide',
  templateUrl: './toggle-slide.component.html',
  providers: [INLINE_EDIT_CONTROL_VALUE_ACCESSOR],
  styleUrls: ['./toggle-slide.component.scss']
})
export class ToggleSlideComponent implements ControlValueAccessor{
  @Input() disable = false;
  @Input() size = 'standard';
  @Input() status = 'standard';
  @Input() position = 'right';
  @Output() change = new EventEmitter<any>();
  @ViewChild('inlineEditControl') inlineEditControl; // input DOM element
  public onChange: any = Function.prototype; // Trascend the onChange event
  public onTouched: any = Function.prototype; // Trascend the onTouch event
  @HostBinding('class.small-slider')
  get small(): boolean {
    return this.size === 'small';
  }
  @HostBinding('class.right-slider')
  get right(): boolean {
    return this.position === 'right';
  }
  @HostBinding('class.left-slider')
  get left(): boolean {
    return this.position === 'left';
  }

  @HostBinding('class.status-primary')
  get primary() {
    return this.status === 'primary';
  }

  @HostBinding('class.status-success')
  get success() {
    return this.status === 'success';
  }

  @HostBinding('class.status-warning')
  get warning() {
    return this.status === 'warning';
  }

  @HostBinding('class.status-danger')
  get danger() {
    return this.status === 'danger';
  }

  @HostBinding('class.status-info')
  get info() {
    return this.status === 'info';
  }

  @HostBinding('class.status-basic')
  get basic() {
    return this.status === 'basic';
  }

  @HostBinding('class.status-control')
  get control() {
    return this.status === 'control';
  }

  id = Math.floor(Math.random() * 5000);
  _value;
  get value(): any {
    return this._value;
  }

  set value(v: any) {
    console.log(v);
      this._value = v;
    this.onChange(v);
  }
  // Required for ControlValueAccessor interface
  writeValue(value: any) {
    this.value = value
  }

  secondary(v) {
    this.value = v;
    this.change.emit(v);
  }

  // Required forControlValueAccessor interface
  public registerOnChange(fn: (_: any) => {}): void {
    this.onChange = fn;
  }

  // Required forControlValueAccessor interface
  public registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }

}
